import { createContext, useContext, useRef } from "react";

interface ScrollPauseCtx {
  pausedRef: React.RefObject<boolean>;
  setPaused: (v: boolean) => void;
}

const ScrollPauseContext = createContext<ScrollPauseCtx>({
  pausedRef: { current: false },
  setPaused: () => {},
});

export function ScrollPauseProvider({ children }: { children: React.ReactNode }) {
  const pausedRef = useRef(false);
  const setPaused = (v: boolean) => {
    pausedRef.current = v;
  };
  return (
    <ScrollPauseContext.Provider value={{ pausedRef, setPaused }}>
      {children}
    </ScrollPauseContext.Provider>
  );
}

export function useScrollPause() {
  return useContext(ScrollPauseContext);
}
